import React from 'react';
import ReactDOM from 'react-dom/client';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, initializeMsal } from './config/authConfig';
import App from './App';
import './index.css';

const DEV_MODE = import.meta.env.VITE_DEV_MODE === 'true';

console.log('DEV_MODE:', DEV_MODE);
console.log('VITE_DEV_MODE env:', import.meta.env.VITE_DEV_MODE);

function renderApp() {
  console.log('Rendering app...');
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <FluentProvider theme={webLightTheme}>
          <App />
        </FluentProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}

if (DEV_MODE) {
  // Skip MSAL initialization in dev mode — avoids hanging on placeholder client ID
  renderApp();
} else {
  initializeMsal().then(renderApp);
}
